import Header from "@/types/app/header";

export default class AuditLogCrud {
  public static header: Header[] = [
    {
      text: "When",
      align: "start",
      sortable: true,
      value: "when",
      class: "item-table-header item-table-header-entryDateTime",
      width: "15%"
    }, 
    {
      text: "What",
      align: "start",
      sortable: true,
      value: "what",
      class: "item-table-header item-table-header-name",
      width: "10%"
    }, 
    {
      text: "Source",
      align: "start",
      sortable: true,
      value: "source",
      class: "item-table-header item-table-header-name",
      width: "10%"
    },    
    {
      text: "Who",
      align: "start",
      sortable: true,
      value: "who",
      class: "item-table-header item-table-header-name",
      width: "10%"
    },
    {
      text: "From Where",
      align: "start",
      sortable: true,
      value: "fromWhere",
      class: "item-table-header item-table-header-name",
      width: "10%"
    },  
    {
      text: "New Values",
      align: "start",
      sortable: true,
      value: "newValues",
      class: "item-table-header item-table-header-newValues",
      width: "20%"
    },  
    {
      text: "Old Values",
      align: "start",
      sortable: true,
      value: "oldValues",
      class: "item-table-header item-table-header-oldValues",
      width: "20"
    },  
    {
      text: "Affected Columns",
      align: "start",
      sortable: true,
      value: "affectedColumns",
      class: "item-table-header item-table-header-affectedColumns",
      width: "10%"
    },   
    {
      text: "",
      align: "right",
      value: "actions",
      sortable: false,
      class: null,
      width: ""
    }
  ];
}
